// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FEF7O2wYPzxwLMZxoojU {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/AppointmentBookingHeader/HeaderMobile/HeaderMobile.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".mobileButtonGroup {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileButtonGroup": `FEF7O2wYPzxwLMZxoojU`
};
export default ___CSS_LOADER_EXPORT___;
